<i class="fa-solid fa-folder" *ngIf="type === typeEnums.FOLDER"></i>
<i
  class="fa-solid"
  [ngClass]="fileIcon"
  iconFallback
  iconFallbackName="fa-file"
  [ngStyle]="{ color: documentIconColorEnum[fileExtension.toUpperCase()] || null }"
  *ngIf="type === typeEnums.MEDIA"
></i>
